// Generates visually distinct colors for a known, fixed count. Hues are spaced
// evenly around the wheel (maximizing separation for that exact count), and
// saturation/lightness are cycled across bands so hue-adjacent colors don't
// end up looking alike at the same brightness.
export const generateDistinctColors = (
  count: number,
  options?: { saturation?: number; lightness?: number }
): string[] => {
  if (count <= 0) {
    return []
  }

  if (count === 1) {
    return [`hsl(0, ${options?.saturation ?? 70}%, ${options?.lightness ?? 50}%)`]
  }

  const saturationBands = options?.saturation ? [options.saturation] : [70, 55, 88]
  const lightnessBands = options?.lightness ? [options.lightness] : [50, 65, 38]
  const hueStep = 360 / count

  return Array.from({ length: count }, (_, index) => {
    const hue = (index * hueStep) % 360
    const band = index % Math.max(saturationBands.length, lightnessBands.length)
    const saturation = saturationBands[band % saturationBands.length]
    const lightness = lightnessBands[band % lightnessBands.length]
    return `hsl(${hue.toFixed(1)}, ${saturation}%, ${lightness}%)`
  })
}
